import { gql } from '@apollo/client';
import getContent from '../../content/getContent';
import graphQLCLient from '../client';
import errorHandler from '../errorHandler';

const getCompanyContactQuery = async () => {
    const client = graphQLCLient();

    const query = gql`{
        getMyCompanyContact {
            contactId
            companyId
            salutation
            firstName
            lastName
            birthDate
            jobTitle
            emailAddress
            status
            mobilePhone
            telephone
            telephoneExtension
            address {
                address1
                address2
                address3
                address4
                city
                region
                postcode
            }
            breeze {
                lastLogin
                registered
            }
        }
    }`;

    return new Promise((resolve, reject) => {
        client.query({ query })
            .then((result) => {
                if (!result.data || !Object.prototype.hasOwnProperty.call(result.data, 'getMyCompanyContact')) {
                    throw new Error(getContent(['errors', 'invalid-graphQL-response']));
                }

                resolve(result.data.getMyCompanyContact);
            })
            .catch((error) => {
                reject(errorHandler(error));
            });
    });
};

export default getCompanyContactQuery;
